import { useQuery } from "@tanstack/vue-query";
import { baseApi } from "../baseApi";
import { useLazyQuery } from "../useLazyQuery";
import {
  type ItemGetZoneRequest,
  type ItemGetZoneResponse,
  type ItemLoadRequest,
  type ItemLoadResponse,
  type ItemUnsetZoneRequest,
  type ItemUnsetZoneResponse,
  type ItemSetZoneRequest,
  type ItemSetZoneResponse,
  type ItemLoadByGuidRequest,
  type ItemLoadByGuidResponse,
} from "./types";

export const itemGetZoneApi = (body: ItemGetZoneRequest) =>
  baseApi<ItemGetZoneResponse, ItemGetZoneRequest>({
    url: "/api/m/item/get_zone",
    method: "POST",
    body,
  });

// TODO: надо бы разобраться с useLazyProductsLoad и useProductsLoad
export const itemLoadApi = (body: ItemLoadRequest) =>
  baseApi<ItemLoadResponse, ItemLoadRequest>({ url: "/api/m/item/load", method: "POST", body });

export const useLazyProductsLoad = () =>
  useLazyQuery<ItemLoadResponse, ItemLoadRequest>({
    queryKey: (params) => (params ? ["short-info-product", ...params.item_id] : ["short-info-product"]),
    queryFn: itemLoadApi,
    staleTime: 0,
  });

export const useProductsLoad = (params: ItemLoadRequest) =>
  useQuery({
    queryKey: ["short-info-product", ...params.item_id],
    queryFn: () =>
      baseApi<ItemLoadResponse, ItemLoadRequest>({ url: "/api/m/item/load", method: "POST", body: params }),
    staleTime: 30_000,
  });

export const itemUnsetZoneApi = (body: ItemUnsetZoneRequest) =>
  baseApi<ItemUnsetZoneResponse, ItemUnsetZoneRequest>({
    url: "/api/m/item/unset_zone",
    method: "POST",
    body,
  });

export const itemSetZoneApi = (body: ItemSetZoneRequest) =>
  baseApi<ItemSetZoneResponse, ItemSetZoneRequest>({
    url: "/api/m/item/set_zone",
    method: "POST",
    body,
  });

export const itemLoadByGuidApi = (body: ItemLoadByGuidRequest) =>
  baseApi<ItemLoadByGuidResponse, ItemLoadByGuidRequest>({
    url: "/api/m/item/load_by_guid",
    method: "POST",
    body,
  });

export const useLazyItemLoadByGuid = () =>
  useLazyQuery<ItemLoadByGuidResponse, ItemLoadByGuidRequest>({
    queryKey: (params) => (params ? ["item-load-by-guid", params.guid] : ["item-load-by-guid"]),
    queryFn: itemLoadByGuidApi,
    staleTime: 0,
  });
